import { Alert, Button, Group, PasswordInput, Stack, Text } from '@mantine/core';
import { IconKey } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { api, errorText } from '../api';
import { notifyOk } from '../notify';

const MIN = 10;

/** Samodzielna zmiana własnego hasła (obecne + nowe, dwa razy). Pozostałe sesje przeglądarki zostają wylogowane. */
export function ChangePasswordSection() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [repeat, setRepeat] = useState('');
  const [error, setError] = useState<string | null>(null);

  const tooShort = next.length > 0 && next.length < MIN;
  const mismatch = repeat.length > 0 && next !== repeat;
  const same = next.length > 0 && next === current;
  const ready = !!current && next.length >= MIN && next === repeat && !same;

  const change = useMutation({
    mutationFn: () => api('/auth/password', { method: 'POST', body: { currentPassword: current, newPassword: next } }),
    onSuccess: () => {
      setCurrent('');
      setNext('');
      setRepeat('');
      setError(null);
      notifyOk('Hasło zmienione. Pozostałe sesje w przeglądarkach zostały wylogowane');
    },
    onError: (e) => setError(errorText(e)),
  });

  return (
    <Stack gap="sm">
      <div>
        <Text fw={700}>Hasło</Text>
        <Text size="sm" c="dimmed">
          Zmiana hasła wyloguje Twoje konto w innych przeglądarkach (ta sesja zostaje). Nowe hasło: co najmniej {MIN} znaków.
        </Text>
      </div>
      {error && <Alert color="red">{error}</Alert>}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (ready) change.mutate();
        }}
      >
        <Stack gap="xs">
          <PasswordInput label="Obecne hasło" autoComplete="current-password" value={current} onChange={(e) => setCurrent(e.currentTarget.value)} />
          <PasswordInput
            label="Nowe hasło"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.currentTarget.value)}
            error={tooShort ? `Co najmniej ${MIN} znaków` : same ? 'Nowe hasło musi się różnić od obecnego' : undefined}
          />
          <PasswordInput label="Powtórz nowe hasło" autoComplete="new-password" value={repeat} onChange={(e) => setRepeat(e.currentTarget.value)} error={mismatch ? 'Hasła nie są takie same' : undefined} />
          <Group justify="flex-end">
            <Button type="submit" leftSection={<IconKey size={16} />} loading={change.isPending} disabled={!ready}>
              Zmień hasło
            </Button>
          </Group>
        </Stack>
      </form>
    </Stack>
  );
}
